import { NavLink as RouterNavLink } from 'react-router-dom';

interface CustomNavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  end?: boolean;
}

export default function NavLink({ to, children, className, end }: CustomNavLinkProps) {
  return (
    <RouterNavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `sidebar-nav__link${isActive ? ' active' : ''}${className ? ` ${className}` : ''}`
      }
    >
      {children}
    </RouterNavLink>
  );
}
